import { Box } from "@mui/material";
import EncampAutocomplete from "components/Forms/EncampAutocomplete";
import { gql } from "generated-graphql";
import { useMemo, useState } from "react";
import { Controller } from "react-hook-form";
import { useDebounce } from "use-debounce";
import { useCommunicationFormContext } from "../hooks/useCommunicationForm";
import { defaultRecipientForm } from "../hooks/useCommunicationForm";

const GET_TENANTS = gql(`
  query GetTenants(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    tenants(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        name
      }
      count
    }
  }
`);

export const TenantPickerSelect = () => {
  const { control, mode, setValue } = useCommunicationFormContext();
  const disabled = mode === "view";

  const [inputValue, setInputValue] = useState("");
  const [debouncedSearch] = useDebounce(inputValue, 150);
  const variables = useMemo(() => {
    return {
      search: debouncedSearch,
      pageSize: 20,
      sort: [{ field: "name", sort: "asc" }],
    };
  }, [debouncedSearch]);

  return (
    <Controller
      name="tenant"
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Box sx={{ width: 296 }}>
          <EncampAutocomplete
            query={GET_TENANTS}
            getItems={(data) => data?.tenants.items ?? []}
            getOptionLabel={(option) => option.name}
            variables={variables}
            value={value}
            onChange={(newVal) => {
              onChange(newVal);
              if (value?.id !== newVal?.id) {
                // Reset all form fields that depend on tenant selection
                setValue("facilities", [], {
                  shouldValidate: true,
                });
                setValue("tierIIReports", [], {
                  shouldValidate: true,
                });
                setValue("communicationDocuments", [], {
                  shouldValidate: true,
                });
                setValue("recipients", [defaultRecipientForm()]);
              }
            }}
            disabled={disabled}
            onInputChange={(newInputValue) => setInputValue(newInputValue)}
            label="Organization"
            error={error}
          />
        </Box>
      )}
    />
  );
};
